import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    amount: Yup.string().required('مبلغ وام ضروری می باشد'),
    number: Yup.string().required('تعداد اقساط ضروری می باشد'),
    // bankAccount: Yup.string().required('انتخاب شماره حساب ضروری می باشد'),
})
